// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getPromotionsDataView } from "@insite/client-framework/Store/Data/Promotions/PromotionsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Loader from "@store/Library/Components/Toolkit/Loader";
import React, { FC } from "react";
import { connect } from "react-redux";
import { orderV2Props } from "@store/Themes/common/props/orderV2";
import CheckoutReviewAndSubmitSplitOrders from "@store/Library/Components/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitSplitOrders";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import useContactUsPageLink from "@store/Framework/Common/Hooks/useContactUsPageLink";

const enum fields {
    showLineNumber = "showLineNumber",
    contactLink = "contactLink",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.showLineNumber]: boolean;
        [fields.contactLink]: LinkFieldValue;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    cartState: getCartState(state, state.pages.orderConfirmation.cartId),
    promotionsDataView: getPromotionsDataView(state, state.pages.orderConfirmation.cartId),
    settingsCollection: getSettingsCollection(state),
    language: state.context.session.language,
});

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface OrderConfirmationSplitOrderProductListStyles {
    orderWrapper?: InjectableCss;
}

export const productListStyles: OrderConfirmationSplitOrderProductListStyles = {
    orderWrapper: orderV2Props.sectionWrapper,
};

const styles = productListStyles;

const OrderConfirmationSplitOrderProductList: FC<Props> = ({
    cartState,
    promotionsDataView,
    fields: { showLineNumber },
}) => {
    const contactLinkUrl = useContactUsPageLink();

    if (!cartState.value || !promotionsDataView.value) {
        return (
            <StyledWrapper {...styles.orderWrapper}>
                <Loader />
            </StyledWrapper>
        );
    }

    return (
        <CheckoutReviewAndSubmitSplitOrders
            cart={cartState.value}
            contactLink={contactLinkUrl.url ?? ""}
            showStatus={true}
            showLineNumber={showLineNumber}
            showNotes={true}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderConfirmationSplitOrderProductList),
    definition: {
        displayName: "Split Order Product List",
        allowedContexts: ["OrderConfirmationPage"],
        group: "Order Confirmation",
        fieldDefinitions: [
            {
                name: fields.showLineNumber,
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                variant: "toggle",
            },
        ],
    },
};

export default widgetModule;
